import * as React from 'react';
import { VacanciesContainer } from '../Vacancies';
import { HeaderContainer } from '../Header/HeaderContainer';
import { ListingLayout } from './components/ListingLayout';
import { FiltersContainer } from '../Filters';
import { FooterContainer } from '../Footer';

export const ListingContainer: React.FC = () => {
  return (
    <ListingLayout
      header={<HeaderContainer withBackground />}
      filters={<FiltersContainer />}
      listing={<VacanciesContainer />}
      footer={<FooterContainer />}
    />
  );
};

ListingContainer.displayName = 'ListingContainer';
